// Family Categories routes
export default [
  {
    path: 'family-categories',
    name: 'familyCategories',
    redirect: 'family-categories/index',
    component: () =>
      import(
        /* webpackChunkName: "familyCategories" */ '../views/familyCategories/FamilyCategories.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'familyCategoriesIndex',
        meta: {
          tabbable: true,
          tableKeys: [],
          filterKeys: [],
          formKeys: [],
          routePermissions: ['familyTypeView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "familyCategoriesIndex" */ '../views/familyCategories/FamilyCategoriesIndex.vue'
          ),
      },
    ],
  },
];
